import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import mailData from "../data/mailData";

import {
  FiAlignRight,
  FiChevronDown,
  FiChevronRight,
  FiXCircle,
} from "react-icons/fi";
import { NavLink } from "react-router-dom";
import "./Navbarmenu.css";
import axios from "axios";
import { baseUrl } from "../Constant";
const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const allowedUsersForContibution = [
    "aluru.akash",
    "ankur.e.mishra",
    "h.srinivasan",
    "jeevadharani.ramanan",
    "arpita.m.singh",
    "uma.rani.battu",
    "reshmi.haridas.m",
    "aayushi.bharti",
    "lavanya.umesh",
    "shramika.s.ambolkar",
    "shubham.i.tyagi",
    "srikanth.narabathoju",
  ];
  const AdminUsers = [
    "uma.rani.battu",
    "h.srinivasan",
    "varsha.a.tyagi",
    "jeevadharani.ramanan",
    "vanitadevi.patil",
    "ankur.e.mishra",
    "lavanya.umesh",
    "aayushi.bharti",
    "shubham.i.tyagi",
    "srikanth.narabathoju",
    "dhanushya.selvaraj",
    "rakesh.sirra"
  ];

  const admins = ["aayushi.bharti", "varsha.a.tyagi"];

  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  const hide = () => setisMenu(false);

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const [temp,setTemp] = useState("")
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }
  useEffect(()=>{
    const homeUrl= async() => {
        const result = await axios.get(`${baseUrl}/homeUrl`,{

        })
        const {data:{Url}} = result
        setTemp(Url);
    }
    homeUrl();
  })
  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row-fluid">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    tabIndex={0}
                    className="menubar__button"
                    style={{ display: "none" }}
                    onFocus={toggleClass}
                  >
                    <FiXCircle />
                  </span>
                </>
              ) : (
                <>
                  <span
                    tabIndex={0}
                    className="menubar__button"
                    style={{ display: "none" }}
                    onFocus={toggleClass}
                  >
                    <FiAlignRight />
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
              <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={() => toggleClass()}
                    href={temp?temp:""}
                    target="_blank"
                  >
                    L&TT Home
                  </a>
                </li>
                <li className="menu-item" onClick={hide}>
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/home`}
                  >
                    Home
                  </NavLink>
                </li>

                <li
                  onClick={toggleSubmenu}
                  className="menu-item sub__menus__arrows"
                >
                  <a
                    className="nav-links"
                    href="/home#LearningOfferings"
                    activeClassName="is-active"
                    aria-expanded="false"
                    aria-haspopup="true"
                    tabindex="0"
                    onClick={hide}
                  >
                    Learning Offerings
                    <span>
                      <FiChevronDown />
                    </span>
                  </a>
                  <ul className={boxClassSubMenu.join(" ")}>
                    <li className="sub__menus__arrows2" onClick={hide}>
                      <NavLink
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        to="/API-Automation-Testing"
                      >
                        Role-based Learning <FiChevronRight />
                      </NavLink>
                      <ul className="sub__menus22">
                        <li onClick={toggleClass}>
                          <NavLink
                            className="nav-links"
                            to="/API-Automation-Testing"
                          >
                            API Automation Testing
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/ManualTesting">
                            Manual Testing
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/SRE">
                            Site Reliability Engineering
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/TOSCA">
                            TOSCA
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li className="sub__menus__arrows0" onClick={hide}>
                      <NavLink
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        to="/PowerBI"
                      >
                        Skill-based Learning <FiChevronRight />
                      </NavLink>
                      <ul className="sub__menus20">
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/PowerBI">
                            Power BI
                          </NavLink>
                        </li>
                        {/* <li onClick={toggleClass}>
             <NavLink className="nav-links" to="/MsPowerBI">
              
              MS Power BI
             </NavLink>
            </li> */}
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/Python">
                            Python
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/SapMM">
                            SAP MM
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li className="sub__menus__arrows1" onClick={hide}>
                      <NavLink
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        to="/GeneralProcess"
                      >
                        Process-based Learning <FiChevronRight />
                      </NavLink>
                      <ul className="sub__menus21">
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/GeneralProcess">
                            General Process
                          </NavLink>
                        </li>
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/SapMM">
                            SAP MM Process
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>

                {/* {allowedUsersForContibution.includes(loggedInEnterpriseId) ? (
         <li className="menu-item" onClick={hide}>
          <NavLink
           activeClassName="is-active"
           className="nav-links"
           onClick={toggleClass}
           to={`/feedback`}
          >
           Feedback
          </NavLink>
         </li>
        ) : (
         ""
        )} */}
                <li className="menu-item" onClick={hide}>
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/dashboard`}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li className="menu-item">
                  <a
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    href={`mailto:${mailData.LKM_ABCUniversity_mail}`}
                  >
                    Contact Us
                  </a>
                </li>
                <li className="menu-item" onClick={hide}>
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/faq`}
                  >
                    FAQs
                  </NavLink>
                </li>
                <li className="menu-item" onClick={hide}>
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/sponsors`}
                  >
                    Sponsors
                  </NavLink>
                </li>
                {AdminUsers.includes(loggedInEnterpriseId) ? (
                  <>
                    <li className="menu-item" onClick={toggleClass}>
                      <NavLink
                        activeClassName="is-active"
                        className="nav-links"
                        onClick={toggleClass}
                        to={`/userMaintenance`}
                      >
                        Admin
                      </NavLink>
                    </li>
                    <li className="menu-item" onClick={hide}>
                      <NavLink
                        activeClassName="is-active"
                        className="nav-links"
                        onClick={toggleClass}
                        to={`/analytics`}
                      >
                        Analytics
                      </NavLink>
                    </li>
                    <li className="menu-item" onClick={hide}>
                      <NavLink
                        activeClassName="is-active"
                        className="nav-links"
                        onClick={toggleClass}
                        to={`/reviews`}
                      >
                        Feedback
                      </NavLink>
                    </li>
                  </>
                ) : null}

                {/* <li className="menu-item" onClick={hide}>
         <NavLink
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          to={`/registedList`}
         >
          Registered List
         </NavLink>
        </li> */}
                {/* <li className="menu-item" onClick={hide}>
         <NavLink
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          to={`/userMaintenance`}
         >
          User Maintenance
         </NavLink>
        </li> */}

                {/* <li className="menu-item" onClick={hide}>
         <NavLink
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          to={`/Nominations`}
         >
          Registered List
         </NavLink>
        </li> */}

                {/* {AdminUsers.includes(loggedInEnterpriseId) ? (
         <li className="menu-item" onClick={hide}>
          <NavLink
           activeClassName="is-active"
           className="nav-links"
           onClick={toggleClass}
           to={`/Admin`}
          >
           Admin
          </NavLink>
         </li>
        ) : null}
        <li className="menu-item" onClick={hide}>
         <NavLink
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          to={`/analytics`}
         >
          Analytics
         </NavLink>
        </li> */}
                {/* ) : null} */}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
